import { render, staticRenderFns } from "./edit-gathering.vue?vue&type=template&id=5b68b8d4&"
import script from "./edit-gathering.vue?vue&type=script&lang=js&"
export * from "./edit-gathering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports